import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../app.css'

const pages = import.meta.glob('../pages/**/*.jsx')

createInertiaApp({
  resolve: async (name) => {
    const page = pages[`../pages/${name}.jsx`]
    if (!page) throw new Error(`Página Inertia no encontrada: ${name}`)
    return (await page()).default
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker', { scope: '/' })
  })
}
